import { useState } from "react";
import { useDispatch } from "react-redux";
import { currentCompany } from "reducers/company/companySlice";
import axios from "utils/axiosConfig";

export function useSubscriptionEditDuration() {
    const dispatch = useDispatch();

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);

    const editDuration = async ({ subscriptionId, startDate, endDate }) => {
        setIsLoading(true);
        setError(null);
        setIsSuccess(false);
        setData(null);

        try {
            const response = await axios.post(
                `/api/subscriptions/${subscriptionId}/edit-duration`,
                {
                    startDate,
                    endDate,
                },
            );
            setData(response?.data);
            setIsSuccess(true);
            if (response?.data) dispatch(currentCompany(response.data));
        } catch (err) {
            const fallbackMsg = "Failed to edit plan's duration.";
            const apiMsg = err?.response?.data?.message;
            setError(apiMsg || fallbackMsg);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        editDuration,
        isLoading,
        error,
        isSuccess,
        data,
    };
}
